import { render, staticRenderFns } from "./LandingPageView.vue?vue&type=template&id=23ff9294&scoped=true"
import script from "./LandingPageView.vue?vue&type=script&lang=js"
export * from "./LandingPageView.vue?vue&type=script&lang=js"
import style0 from "./LandingPageView.vue?vue&type=style&index=0&id=23ff9294&prod&scoped=true&lang=scss"
import style1 from "./LandingPageView.vue?vue&type=style&index=1&id=23ff9294&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ff9294",
  null
  
)

export default component.exports